module.exports = __webpack_public_path__ + "img/venteny.f586e45e.jpeg";